module.exports = __webpack_public_path__ + "static/media/german_dump_120.0562fc79.png";